/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type DigitalWithdrawalRequestStatus = typeof DigitalWithdrawalRequestStatus[keyof typeof DigitalWithdrawalRequestStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DigitalWithdrawalRequestStatus = {
  requested: 'requested',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;
